import store from '@/store'
import { inMerchantManager } from '@/utils/common/env'

// 动态导入elvish以处理模块解析错误
let elvishModule = null

async function loadElvish() {
  try {
    elvishModule = await import('@didi/elvish-lib-javascript')
    return elvishModule
  } catch (error) {
    console.warn('无法加载 elvish-lib-javascript:', error)
    return null
  }
}

const defaultConfig = {
  lang: 'es-MX',
  countryCode: 'MX',
  cityId: '52140500',
}

export async function getElvish() {
  const { state = {} } = store
  const { globalParams = {} } = state
  const { lang = '', countryCode = '', cityId = '' } = globalParams

  try {
    const elvish = await loadElvish()
    if (elvish && elvish.init && elvish.setCity && elvish.getCapitalCity) {
      const effectiveCountryCode = countryCode || defaultConfig.countryCode
      await elvish.init(lang || defaultConfig.lang, effectiveCountryCode)

      // 管理端app场景bridge 公参不含 cityId，通过 getCapitalCity 获取首都城市 ID
      let effectiveCityId = cityId
      if (inMerchantManager) {
        const capitalCityInfo = elvish.getCapitalCity(effectiveCountryCode)
        effectiveCityId = capitalCityInfo?.cityid || ''
        if (effectiveCityId) {
          store.commit('UPDATE_GLOBAL_PARAMS', {
            ...globalParams,
            cityId: effectiveCityId,
          })
        }
      }

      await elvish.setCity(effectiveCityId || defaultConfig.cityId)
      console.log('Elvish 初始化成功')
    } else {
      console.warn('Elvish 模块加载失败，使用默认配置')
    }
  } catch (e) {
    console.error('Elvish 初始化错误:', e)
    // 应用可以继续运行，只是没有elvish功能
  }
}
